import ChatModel, { RawMessage } from "@/models/chat";
import { User } from "@/controller/user";

export interface Message {
  isFromCustomer: boolean;
  staffName?: string;
  text?: string;
  images?: string[];
  date: Date;
}

export default class ChatController {
  private userProfile: User;

  constructor(userProfile: User) {
    this.userProfile = userProfile;
  }

  public async watchChat(callbackToClient: Function) {
    const callbackFromController = (rawMessages: RawMessage[]) => {
      const messages: Message[] = this.cookRawMessages(rawMessages);
      callbackToClient(messages);
    };

    ChatModel.watchChat(this.userProfile.phone, callbackFromController);
  }

  public stopWatchingChat() {
    ChatModel.stopWatchingChat();
  }

  private cookRawMessages(rawMessages: RawMessage[]): Message[] {
    return rawMessages.map((rawMessage) => {
      return {
        isFromCustomer: rawMessage.isFromCustomer,
        staffName: rawMessage.staffName || "",
        text: rawMessage.text,
        images: rawMessage.images,
        date: new Date(rawMessage.dateMSec)
      };
    });
  }

  public async sendTextMessage(text: string) {
    const rawMessage: RawMessage = this.prepareRawTextMessage(text);
    return ChatModel.sendMessage(this.userProfile, rawMessage);
  }

  private prepareRawTextMessage(text: string): RawMessage {
    return {
      isFromCustomer: true,
      text,
      dateMSec: new Date().getTime()
    };
  }

  public async sendImageMessage(images: string[]) {
    const rawMessage: RawMessage = this.prepareRawImageMessage(images);
    return ChatModel.sendMessage(this.userProfile, rawMessage);
  }

  private prepareRawImageMessage(images: string[]): RawMessage {
    return {
      isFromCustomer: true,
      images,
      dateMSec: new Date().getTime()
    };
  }
}
